import React from "react";
import {Card} from "antd";
import DictTree from "./DictTree";
import DictForm from "./DictForm";
import {useModel} from "../../../models";
import {OptType} from "./dictModel";

export default function () {
    const [{optType},] = useModel("dict");
    return (
        <div style={{display: "flex", height: "98%"}}>
            <DictTree/>
            <div className="margin-top-8 margin-left-8" style={{flex: "1"}}>
                <Card
                    title={<h3>{optType === OptType.DETAIL ? "字典信息" : "添加字典"}</h3>}
                    bordered={true}
                >
                    <div style={{width: "600px"}}>
                        <DictForm/>
                    </div>
                </Card>
            </div>
        </div>
    )

};